// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDyJcowKJqQNeQzLL6i7_z1F5TqGupIvog",
  authDomain: "auction-app-30d78.firebaseapp.com",
  projectId: "auction-app-30d78",
  storageBucket: "auction-app-30d78.firebasestorage.app",
  messagingSenderId: "157233741576",
  appId: "1:157233741576:web:977b4d3c66a384cf22f6bd",
  measurementId: "G-T811V10B66"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const analytics = getAnalytics(app);
const auth = getAuth(app)

export { db, storage, analytics, auth };
